import {TagApiDto} from "../../api/model/rest";

/**
 * Tag model.
 */
export default class Tag {
	constructor(public readonly name: string) {}
	
	static fromJson(json: TagApiDto): Tag {
		return new Tag(json.name);
	}
}